import { cn } from "@/lib/utils";

function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return <div data-slot='skeleton' className={cn("bg-bg-muted skeleton-shine rounded-md", className)} {...props} />;
}

export { Skeleton };
